<template>
  <div class="section-content">
    <div v-for="(product, key) in products" :key="key" class="item col-6">
      <product-block :info="product" :gaEvent="gaEvent" />
    </div>
  </div>
</template>

<script>
import ProductBlock from '@/components/ProductBlock'
export default {
  name: 'TwoColumn',
  components: {
    ProductBlock,
  },
  props: {
    gaEvent: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.section-content {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;

  .item {
    padding: 0 0 20px 0;

    &:nth-of-type(odd) {
      padding-right: 8px;
    }
    &:nth-of-type(even) {
      padding-left: 8px;
    }

    img {
      width: 100%;
    }

    .product-block {
      height: 100%;
    }
  }
}
</style>
